module.exports = __webpack_public_path__ + "static/Onlay upper before-840b1b758c61ed264004da10470c17c9.jpg";